/**
 * ValueInput — renders the appropriate input for a filter condition value.
 */
import React from 'react';
import { Input } from '../ui/input';

export default function ValueInput({ cond, fieldDef, fType, onChange }) {
  const upd = (v) => onChange({ ...cond, value: v });
  const isMulti = cond.operator === 'in' || cond.operator === 'not_in';

  if (fType === 'enum' && fieldDef?.options?.length > 0) {
    if (isMulti) {
      return (
        <select multiple value={Array.isArray(cond.value) ? cond.value : []}
          onChange={e => upd(Array.from(e.target.selectedOptions, o => o.value))}
          className="h-14 text-xs border rounded px-1.5 w-[180px] bg-white" data-testid="filter-value-multiselect">
          {fieldDef.options.map(o => <option key={o} value={o}>{o}</option>)}
        </select>
      );
    }
    return (
      <select value={cond.value || ''} onChange={e => upd(e.target.value)}
        className="h-7 text-xs border rounded px-1.5 w-[180px] bg-white" data-testid="filter-value-enum">
        <option value="">-- Select --</option>
        {fieldDef.options.map(o => <option key={o} value={o}>{o}</option>)}
      </select>
    );
  }

  if (fType === 'boolean') {
    return (
      <select value={String(cond.value)} onChange={e => upd(e.target.value === 'true')}
        className="h-7 text-xs border rounded px-1.5 w-[100px] bg-white" data-testid="filter-value-bool">
        <option value="true">Yes</option><option value="false">No</option>
      </select>
    );
  }

  if (cond.operator === 'between') {
    const arr = Array.isArray(cond.value) ? cond.value : ['', ''];
    const iType = fType === 'number' ? 'number' : 'date';
    return (
      <div className="flex items-center gap-1">
        <Input type={iType} value={arr[0] || ''} onChange={e => upd([e.target.value, arr[1] || ''])}
          className="h-7 text-xs w-[110px]" placeholder="From" data-testid="filter-value-from" />
        <span className="text-[10px] text-muted-foreground">to</span>
        <Input type={iType} value={arr[1] || ''} onChange={e => upd([arr[0] || '', e.target.value])}
          className="h-7 text-xs w-[110px]" placeholder="To" data-testid="filter-value-to" />
      </div>
    );
  }

  let iType = 'text';
  if (fType === 'number') iType = 'number';
  else if (fType === 'date' || fType === 'datetime') iType = 'date';
  return (
    <Input type={iType} value={cond.value || ''} onChange={e => upd(e.target.value)}
      className="h-7 text-xs w-[180px]" placeholder={isMulti ? 'val1, val2, ...' : 'Value'}
      data-testid="filter-value-input" />
  );
}
